<button
  class="form-action-button--base"
  [ngClass]="{
    destructive: buttonType === nativeButtonType.RESET,
    nocasing: type() === actionType.ADD,
    small: size === buttonSize.SMALL
  }"
  [type]="buttonType"
  [attr.data-test-id]="testId"
  [disabled]="disabled"
  (click)="onClick()"
>
  {{ buttonText() }}
  @if (icon) {
  <svg
    [attr.width]="iconSize"
    [attr.height]="iconSize"
    [attr.viewBox]="iconViewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    @if (type() === actionType.SAVE) {
    <path
      d="M11.4169 4.88109C11.7028 4.59522 12.1663 4.59522 12.4522 4.88109C12.7381 5.16697 12.7381 5.63046 12.4522 5.91633L7.511 10.8575C7.22513 11.1434 6.76164 11.1434 6.47576 10.8575L3.54766 7.92941C3.26178 7.64353 3.26178 7.18004 3.54766 6.89416C3.83353 6.60829 4.29702 6.60829 4.5829 6.89416L6.99338 9.30465L11.4169 4.88109Z"
      fill="#1100DB"
    />
    } @if (type() === actionType.EDIT) {
    <path
      d="M2.66675 11.2342V13.0354C2.66675 13.2013 2.7971 13.3316 2.963 13.3316H4.76423C4.84126 13.3316 4.91829 13.302 4.97161 13.2428L11.4418 6.77848L9.21991 4.55657L2.75562 11.0209C2.69637 11.0801 2.66675 11.1512 2.66675 11.2342ZM13.1601 5.0602C13.3912 4.82912 13.3912 4.45584 13.1601 4.22476L11.7736 2.83829C11.5426 2.60721 11.1693 2.60721 10.9382 2.83829L9.8539 3.92258L12.0758 6.14449L13.1601 5.0602Z"
      fill="#1100DB"
    />
    } @if (type() === actionType.ADD) {
    <path
      d="M11.9987 8.66683H8.66536V12.0002C8.66536 12.3668 8.36536 12.6668 7.9987 12.6668C7.63203 12.6668 7.33203 12.3668 7.33203 12.0002V8.66683H3.9987C3.63203 8.66683 3.33203 8.36683 3.33203 8.00016C3.33203 7.6335 3.63203 7.3335 3.9987 7.3335H7.33203V4.00016C7.33203 3.6335 7.63203 3.3335 7.9987 3.3335C8.36536 3.3335 8.66536 3.6335 8.66536 4.00016V7.3335H11.9987C12.3654 7.3335 12.6654 7.6335 12.6654 8.00016C12.6654 8.36683 12.3654 8.66683 11.9987 8.66683Z"
      fill="#1100DB"
    />
    } @if (type() === actionType.DELETE) {
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.8171 18.6668C12.1291 18.6668 11.5454 18.1299 11.4885 17.4437L10.7009 8.00016H9.77648C9.53114 8.00016 9.33203 7.80105 9.33203 7.55572C9.33203 7.31038 9.53114 7.11127 9.77648 7.11127H13.332V6.66683C13.332 5.93142 13.93 5.3335 14.6654 5.3335H17.332C18.0674 5.3335 18.6654 5.93142 18.6654 6.66683V7.11127H22.2209C22.4663 7.11127 22.6654 7.31038 22.6654 7.55572C22.6654 7.80105 22.4663 8.00016 22.2209 8.00016H21.2965L20.5095 17.4443C20.4526 18.1299 19.8689 18.6668 19.1809 18.6668H12.8171ZM12.3738 17.3702C12.3928 17.599 12.5871 17.7779 12.8171 17.7779H19.1809C19.4103 17.7779 19.6052 17.599 19.6236 17.3702L20.4046 8.00016H11.5928L12.3738 17.3702ZM17.7765 7.11127V6.66683C17.7765 6.4215 17.5774 6.22238 17.332 6.22238H14.6654C14.42 6.22238 14.2209 6.4215 14.2209 6.66683V7.11127H17.7765ZM14.6654 15.5557C14.42 15.5557 14.2209 15.3566 14.2209 15.1113V10.6668C14.2209 10.4215 14.42 10.2224 14.6654 10.2224C14.9107 10.2224 15.1098 10.4215 15.1098 10.6668V15.1113C15.1098 15.3566 14.9107 15.5557 14.6654 15.5557ZM16.8876 15.1113C16.8876 15.3566 17.0867 15.5557 17.332 15.5557C17.5774 15.5557 17.7765 15.3566 17.7765 15.1113V10.6668C17.7765 10.4215 17.5774 10.2224 17.332 10.2224C17.0867 10.2224 16.8876 10.4215 16.8876 10.6668V15.1113Z"
      fill="#DC1F3F"
    />
    }
  </svg>
  }
</button>
